export default {
  categoryDescriptionRules: [
    (v) =>
      (!!v && v.length <= 50) ||
      "Description is required and must be less than 50 characters",
      (v) => v.trim().length > 0 || "Description cannot be empty"
    ],
  descriptionRules: [
    (v) => (!!v && v.length <= 35) || "Description is required and must be less than 35 characters",
    (v) => v.trim().length > 0 || "Description cannot be empty"
  ],
  quantityRules: [
    (v) => !!v || "Quantity is required",
    (v) => (new RegExp(/^[1-9]{1}[0-9]{0,5}$/)).test(v) || "Quantity must be a whole number, made up of at most 6 digits"
  ],
  weightRules: [
    (v) => !!v || "Weight is required",
    (v) => (new RegExp(/^[1-9]{1}[0-9]{0,5}$/)).test(v) || "Weight must be a whole number, made up of at most 6 digits"
  ],
  valueRules: [
    (v) => !!v || "Value is required",
    (v) => (new RegExp(/^[1-9]{1}[0-9]{0,6}$/)).test(v) || "Value must be a whole number, made up of at most 7 digits"
  ],
  valueRulesAllowingZero: [
    (v) => typeof v === "number" || "Value is required",
    (v) => (new RegExp(/^[0-9]{0,7}$/)).test(v) || "Value must be a whole number, made up of at most 7 digits"
  ],
  nameRules: [
    (v) => !!v || "Name is required",
    (v) => v.length <= 14 || "Name must be at most 14 characters",
    (v) => v.trim().length > 0 || "Name cannot be empty"
  ],
  lastNameRules: [
    (v) => !!v || "Last name is required",
    (v) => v.length <= 20 || "Last name must be at most 20 characters",
    (v) => v.trim().length > 0 || "Last name cannot be empty"
  ],
  addressLine1Rules: [
    (v) => !!v || "Address Line 1 is required",
    (v) => v.length <= 50 || "Address Line 1 must be at most 50 characters",
    (v) => v.trim().length > 0 || "Address Line 1 cannot be empty"

  ],
  addressLine2Rules: [
    (v) =>
      !v ||
      v.length <= 50 ||
      "Address Line 2 must be at most 50 characters",
      (v) => !v || v.trim().length > 0 || "Address Line 2 cannot be empty"
  ],
  genericPostcodeRules: [
    (v) => !!v || "Post Code is required",
    (v) => v.length <= 17 || "Post Code must be at most 17 characters",
    (v) => v.trim().length > 0 || "Post code cannot be empty"
  ],
  localPostcodeRules: [
    (v) => !!v || "Post Code is required",
    (v) => (new RegExp(/^[a-zA-Z]{3}\s?\d{4}$/)).test(v) || "Post Code must consist of 3 letters followed by 4 digits"
  ],
  localLocalityRules: [(v) => !!v || "Locality is required"],
  genericLocalityRules: [
    (v) => !!v || "Locality is required",
    (v) => v.length <= 35 || "Locality must be at most 35 characters",
    (v) => v.trim().length > 0 || "Locality cannot be empty"
  ],
  countryRules: [(v) => !!v || "Country is required"],
  emailRules: [
    (v) =>
      !v ||
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) ||
      "E-mail is not valid",
    (v) => v.length <= 50 || "Email must be at most 50 characters"
  ],
  hscodeRules: [
    (v) => !!v || "HS Code is required",
    (v) => !v || (new RegExp(/^[0-9]{6}([0-9]{2}){0,2}$/)).test(v) || "HS Code must be 6, 8 or 10 digits. Alphabetic Prefixes are not supported."
  ],
  hscodeRulesDropDow: [
    (v) => !!v || "HS Code is required"
  ],
  countryOfOriginRules: [
    (v) => !!v || "Country of Origin is required"
  ],
  phoneRules: [
    (v) => !v || v.length <= 20 || "Phone number must be at most 20 digits.",
    (v) => (new RegExp(/^[0-9]*$/)).test(v) || "Phone number must contain only digits"
  ],
  mandatoryPhoneRules: [
    (v) => !!v || "Phone number is required",
    (v) => !v || v.length <= 20 || "Phone number must be at most 20 digits.",
    (v) => (new RegExp(/^[0-9]*$/)).test(v) || "Phone number must contain only digits"
  ],
  consignorIdNumberRules: [
    (v) => !!v || "Id number is required",
  ],
  vatNumberSenderRules: [
    (v) => v.length <= 10 || "VAT number must be at most 10 characters",
    (v) => !v || v.trim().length > 0 || "VAT number cannot be empty"    
  ],
  vatNumberRecipientRules: [
    (v) => v.length <= 20 || "VAT number must be at most 20 characters",
    (v) => !v || v.trim().length > 0 || "VAT number cannot be empty"    
  ],
  voecNumberSenderRules: [
    (v) => v.length <= 7 || "VOEC number must be at most 7 characters",
    (v) => (new RegExp(/^[0-9]*$/)).test(v) || "VOEC number must contain only digits"
  ],
  consignorRadioButtonRules: [
    (v) => v !== null || 'Please select Yes or No'
  ]
};